export const CenterOpsUserRole = {
  STAFF: 'Staff',
  MANAGER: 'Manager'
}
